const params = new URLSearchParams(window.location.search);

const defaultTransform = (value) => value === '1' || value === 'true';

// Add new feature flags here.
// - Unless a transform function is specified, defaultTransform will be used.
//     transform is applied to the url param or process.env value,
//     but not to the defaultValue.
// - The envValue will be evaluated as the process.env variable with the same
//     name as the feature flag, plus the prefix 'REACT_APP_'. NOTE: env vars
//     are only exposed to the frontend if they begin with 'REACT_APP_'.
// - If a flag is not specified in the url params or process.env,
//     defaultValue will be used (without applying transform). defaultValue
//     defaults to false.
// - If a flag value is specified in both the url params and process.env,
//     the url param will take precedence.
// - If a flag value is specified in the url params, it will be persisted
//     for the duration of the session.
//
// Example entries
// ---------------
// NUMERIC_FLAG: {
//    transform: (value) => parseInt(value),
// }
// LAUNCHED_FLAG: {
//    defaultValue: true,
// }

// Add feature flags here.
const envFlags = {
  FREE_TRIAL_LENGTH: {
    transform: (value) => parseInt(value, 10),
  },
};

const featureFlagValue = (flagName) => {
  const { defaultValue = false, transform = defaultTransform } = envFlags[
    flagName
  ];
  // Get flag from url param or process.env
  const paramValue = params.get(flagName);
  // Evaluate environment variable with REACT_APP_ prefix
  const envValue = process.env[`REACT_APP_${flagName}`];
  return paramValue != null
    ? transform(paramValue)
    : envValue != null
    ? transform(envValue)
    : defaultValue;
};

export const featureFlags = Object.keys(envFlags).reduce(
  (acc, flagName) => ({
    ...acc,
    [flagName]: featureFlagValue(flagName),
  }),
  {},
);

const showFeatureFlags = () => {
  console.info('Feature Flags:', featureFlags);
};

// Show feature flags in the console in dev env.
if (process.env.NODE_ENV === 'development') {
  showFeatureFlags();
}

// Enable access to featureFlags in all envs.
window.showFeatureFlags = showFeatureFlags;
